import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'scientific-free-response',
})

export default class ScientificFreeResponse extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    private get answerObject() {
        return this.content.answerObject;
    }

    // ---------------------------------------------------------------
    // Hooks


    // --------------------------------------------------------------
    // Methods

    private parseAnswerObject() {
        const answerDetails = this.answerObject;
        const userAnswers: any = [];
        if (answerDetails) {
          answerDetails.map((answer: any) => {
            const answerValue = answer.text.split(':');
            userAnswers.pushObject({
              category: answerValue[0],
              value: answerValue[1],
            });
          });
        }
        return userAnswers;
    }




}
